module.exports = __webpack_public_path__ + "static/media/RAO_NTS_report_11.d5697945.pdf";